import { API } from 'aws-amplify';
import { API_NAME, getConfig, handleError, validateResponse } from './apiUtils';

export function createPrizeItem(market, category, brand, body) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/prize-item`;
    return getConfig(body)
        .then((config) => API.post(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getPrizeItem(market, category, brand, prizeId) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/prize-item/${prizeId}`;
    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getPrizeItemList(market, category, brand) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/prize-item`;

    return getConfig()
        .then((config) => API.get(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function updatePrizeItem(market, category, brand, prizeId, body) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/prize-item/${prizeId}`;

    return getConfig(body)
        .then((config) => API.put(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function deletePrizeItem(market, category, brand, prizeId) {
    const path = `/v1/loyaltyadmin/${market}/${category}/${brand}/prize-item/${prizeId}`;

    return getConfig()
        .then((config) => API.del(API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
